import React from "react";
import { ArrowRight } from "lucide-react";
import content from "@/data/content.json";
import { AccentH2, Container, Label, Reveal, Section } from "./Primitives";
import { FlowLines } from "./FlowLines";

const { leistungen } = content;

export const Leistungen = ({ excludeHref }) => {
  const cards = excludeHref ? leistungen.cards.filter((c) => c.href !== excludeHref) : leistungen.cards;
  return (
  <Section
    id="leistungen"
    testId="section-leistungen"
    className="has-lines bg-[#1e2532] text-white on-dark overflow-hidden"
  >
    <FlowLines />
    <Container className="relative z-10">
      <div className="grid grid-cols-1 items-end gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
        <Reveal>
          <Label>{leistungen.label}</Label>
          <AccentH2 className="mt-6 font-bold">{leistungen.h2}</AccentH2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="max-w-[620px] text-[17px] leading-[1.8] text-white/70">{leistungen.intro}</p>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {cards.map((c, i) => (
          <Reveal key={c.h3} delay={(i % 3) * 0.07}>
            <a
              href={c.href}
              data-testid={`leistung-card-${i}`}
              className="service-card group flex h-full cursor-pointer flex-col rounded-[14px] border border-white/12 bg-white/[0.03] p-5"
            >
              <div className="img-frame relative aspect-[16/10] w-full">
                <img src={c.image} alt={c.imageAlt} loading="eager" decoding="async" width="1264" height="848" />
                <span className="service-card__badge absolute bottom-3 right-3 flex h-10 w-10 items-center justify-center rounded-full bg-[#0f9d6e] text-white">
                  <ArrowRight size={18} />
                </span>
              </div>

              <h3 className="mt-6 font-semibold">{c.h3}</h3>
              <span className="accent-rule mt-3" aria-hidden="true" />
              <p className="mt-4 flex-1 text-[15.5px] leading-[1.72] text-white/62">{c.text}</p>

              <span className="mt-6 inline-flex items-center gap-2 text-[13.5px] font-bold uppercase tracking-[0.12em] text-[#3ecf9b]">
                <span className="link-underline">Mehr erfahren</span>
                <ArrowRight size={15} />
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </Container>
  </Section>
  );
};
